export default Object.freeze({
  None: 'none',
  ByteArray: 'byte-array',
  Base64String: 'base64-string',
  ZipByteArray: 'zip-byte-array',
  ZipBase64String: 'zip-base64-string',
  HttpBodyBinaryData: 'http-body-binary-data',
});
